// extracted by mini-css-extract-plugin
export default {"buttonContainer":"results_buttonContainer__O8Yio"};